import { render, staticRenderFns } from "./FormKasbonApproval.vue?vue&type=template&id=3ce9c7c0"
import script from "./FormKasbonApproval.vue?vue&type=script&lang=js"
export * from "./FormKasbonApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports